<template>
  <b-card>

    <field-add-content :field-group-id="fieldGroupId" class="mt-2 pt-75"/>
  </b-card>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BSpinner
} from 'bootstrap-vue'
import FieldAddContent from './FieldAddContent.vue'
import router from '@/router'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BSpinner,
    FieldAddContent,
  },
  data() {
    return {
      fieldGroupId: router.currentRoute.params.id
    }
  },
}
</script>